var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
function IconLotSize(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 20 20" }, props),
        React.createElement("path", { fillRule: "evenodd", d: "M17 17.75V2.25a.75.75 0 00-.75-.75h-12a.75.75 0 00-.75.75v15.5c0 .414.336.75.75.75h12a.75.75 0 00.75-.75zm-3.8-7.171L5.62 3H15.5v5.297l-2.3 2.281zM5 4.5l7.14 7.14L6.777 17H5V4.5zM15.485 17h.015v-.015l-.015.015zM13.5 17l-2.3-2.3L8.9 17h4.6zm-1.24-3.36l3.24-3.24v6.479l-3.24-3.24z", clipRule: "evenodd" })));
}
export default IconLotSize;
